var FreeGift = class extends HTMLElement {
  static _settling = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.settings = JSON.parse(document.querySelector(`[data-gift-settings]`).innerHTML);
    this.enforceOneGift();
    this._onCart = () => this.enforceOneGift();
    document.documentElement.addEventListener('cart:updated', this._onCart);
  }

  disconnectedCallback() {
    if (this._onCart) {
      document.documentElement.removeEventListener('cart:updated', this._onCart);
    }
  }

  /**
   * Remove the gift this cart has stopped earning.
   *
   * The offer is two spend bands and ONE gift that changes between them: the
   * book light from 200, the Xmas lights INSTEAD from 240. The published FAQ
   * is the authority -- "Customers who qualify for more than one gift with
   * purchase offer will receive the higher-value gift only."
   *
   * Everything else is handled server side. multi-tier-gwp.liquid publishes
   * only the gift the band has earned, so the thing that adds gifts can only
   * ever add that one. The single case Liquid cannot fix is a cart that earned
   * the book light and then crossed 240: the old gift is already a line item
   * and no amount of re-rendering removes it.
   *
   * So the server says so. `removeInCart` is computed from cart.items in
   * Liquid, not inferred here, which matters because this used to be a client
   * side threshold race -- the whole original testThreshold body is still
   * below, commented out, and it is the reason nothing reliable happened.
   *
   * This cannot loop. At the moment it fires, neither published id names the
   * gift being removed, so nothing re-adds it; the section then re-renders
   * with removeInCart false and the condition is gone. The in-flight flag
   * covers the window before that render lands.
   */
  enforceOneGift() {
    const node = document.querySelector(`[data-gift-settings]`);
    if (!node) return;
    let s;
    try {
      s = JSON.parse(node.innerHTML);
    } catch (e) {
      return;
    }
    // Gated: a bundle (or another line-level discount) is on the cart and the
    // theme has withdrawn the offer. custom.js clears _gwp1/_gwp2 on the NEXT
    // cart update, but the update that completed the bundle may have read the
    // previous, ungated block and set them a beat earlier. The re-rendered
    // drawer knows both the gate and what the cart attributes hold, so it
    // clears them here. Terminates: once cleared, the next render carries
    // empty attrs and this does nothing.
    if (s.gated) {
      if (!s.attrOne && !s.attrTwo) return;
      if (FreeGift._settling) return;
      FreeGift._settling = true;
      this._updateCart({ attributes: { _gwp1: '', _gwp2: '' } })
        .catch(() => {})
        .then(() => { FreeGift._settling = false; });
      return;
    }
    if (!s.removeInCart || !s.removeId) return;
    if (FreeGift._settling) return;
    FreeGift._settling = true;
    this._updateCart({ updates: { [s.removeId]: 0 } })
      .catch(() => {})
      .then(() => { FreeGift._settling = false; });
  }

  testThreshold(cart, event){
    /* disabled for now
    console.log(cart)
    console.log('test:'+this.settings.giftInCart+' / '+this.cartTotal+' / '+this.settings.threshold)
    if(event) {
      this.cartTotal = parseFloat(cart.detail["cart"]["total_price"]);
    } else {
      if(cart){
        this.cartTotal = cart.total_price;
      } else {
        this.cartTotal = this.settings.cartTotal;
      }
    }
    console.log(this.cartTotal)
    if(this.settings.giftInCart && this.cartTotal < this.settings.threshold) {
      let formData = {
        updates: {
          [this.settings.giftId]: 0,
          [this.settings.giftTwoId]: 0,
        }
      };
      this._updateCart(formData)
    }
    if(this.cartTotal >= this.settings.threshold && this.cartTotal < this.settings.thresholdTwo) {
      let formData = {
        updates: {
          [this.settings.giftId]: 1,
          [this.settings.giftTwoId]: 0,
        }
      };
      this._updateCart(formData)
    }
    if(!this.settings.giftTwoInCart && this.cartTotal >= this.settings.thresholdTwo) {
      let formData = {
        updates: {
          [this.settings.giftId]: 1,
          [this.settings.giftTwoId]: 1,
        }
      };
      this._updateCart(formData)
    }
    */
  }

  async _updateCart(formData) {
    return new Promise((resolve, reject) => {
      fetch(`/cart/update.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then((response) => {
        const updatedCart = response;
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: updatedCart
          }
        }));
        resolve(updatedCart);
        this.updateGWP();
      })
      .catch((e) => {
          console.error(e);
          reject(e);
      })
    });
  }


  async updateGWP() {
    const res = await fetch(`${window.themeVariables.routes.rootUrl}?section=shopify-section-mini-cart`)
    const section = await res.text();
    const cart = document.createElement('div');
    cart.innerHTML = section;
    const updatedCart = cart.querySelector(`cart-drawer .drawer__content`);
    const currentCart = document.querySelector(`cart-drawer .drawer__content`);
    if (currentCart && updatedCart) {
      currentCart.innerHTML = updatedCart.innerHTML;
    }
  }
};
window.customElements.define('gift-with-purchase', FreeGift);

document.addEventListener("cart:updated", (event) => {
  //document.querySelector('gift-with-purchase').testThreshold(event, true)
});

document.addEventListener("DOMContentLoaded", (event) => {
  //document.querySelector('gift-with-purchase').testThreshold(false, false)
});